/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.trades', [
      'admin.users.details.trades.details'
    ])
    .controller('UserTradesAdminCtrl', UserTradesAdminCtrl);

  /** @ngInject */
  function UserTradesAdminCtrl($scope, $state, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = 'ts-m-desc';
    vm.sortReverse = false;

    vm.options = [
      {
        id: 0,
        name: 'All'
      },
      {
        id: 1,
        name: 'Active'
      },
      {
        id: 2,
        name: 'Executed'
      },
      {
        id: 3,
        name: 'Expired'
      },
      {
        id: 4,
        name: 'Ended by user A'
      },
      {
        id: 5,
        name: 'Ended by user B'
      }
    ];


    var filterCache = localStorage.getItem('filter_trade');
    if (filterCache !== null) {
      vm.option = parseInt(filterCache);
    } else {
      vm.option = vm.options[0].id;
      localStorage.setItem('filter_trade', vm.option);
    }

    load(1);

    var oldSortType;
    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      oldSortType = angular.copy(vm.sortType);
      if (vm.option === 0) {
        UsersService.listTrades($stateParams.parentId, vm.oldPage, 25, vm.sortType).then(success);
      } else {
        UsersService.listTradesByStatus($stateParams.parentId, vm.oldPage, 25, vm.sortType, vm.option).then(success);
      }

      function success(result){
        var items = result.results;
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < items.length; i++) {
          var ubId = items[i].ub === undefined ? 0 : items[i].ub.id;
          if (ubId !== 0 && parseInt(vm.userId) === ubId) {
            items[i].username2 = items[i].ua === undefined ? '' : items[i].ua.username;

            switch(items[i].st) {
              case 0:
                items[i].status = 'Unknown';
                break;
              case 1:
                items[i].status = 'Active';
                break;
              case 2:
                items[i].status = 'Executed';
                break;
              case 3:
                items[i].status = 'Expired';
                break;
              case 4:
                items[i].status = 'Ended By User ' + items[i].ub === undefined ? '' : items[i].ub.username;
                break;
              case 5:
                items[i].status = 'Ended By User ' + items[i].ua === undefined ? '' : items[i].ua.username;
                break;
            }
          } else {
            items[i].username2 = items[i].ub === undefined ? '' : items[i].ub.username;

            switch(items[i].st) {
              case 0:
                items[i].status = 'Unknown';
                break;
              case 1:
                items[i].status = 'Active';
                break;
              case 2:
                items[i].status = 'Executed';
                break;
              case 3:
                items[i].status = 'Expired';
                break;
              case 4:
                items[i].status = 'Ended By User ' + items[i]['ua'] === undefined ? '' : items[i]['ua'].username;
                break;
              case 5:
                items[i].status = 'Ended By User ' + items[i]['ub'] === undefined ? '' : items[i]['ub'].username;
                break;
            }
          }

          items[i].ts = new Date(parseInt(result.results[i].ts.toString().substring(0, result.results[i].ts.toString().length - 3)));
          items[i]['ts-m'] = new Date(parseInt(result.results[i]['ts-m'].toString().substring(0, result.results[i]['ts-m'].toString().length - 3)));
        }

        vm.sortType = oldSortType;
        vm.items = items;
      }
    }

    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      load(vm.pagination.current);
    };

    vm.choose = function(){
      vm.sortType = oldSortType;
      localStorage.setItem('filter_trade', vm.option);
      load(vm.pagination.current);
    };

    vm.pageChanged = function(newPage) {
      vm.sortType = oldSortType;
      load(newPage);
    };

    vm.next = function(id){
      var items = _.filter(vm.items, {'id': parseInt(id)})[0];
      $state.go('admin.users.details.trades.details', {details: items});
    };

  }

})();
